import SoftBox from "components/SoftBox";
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";

import Schedules from "layouts/pages/library/schedules";

const Calendar = () => {
  return (
    <>
      <div style={{
        padding: "8px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "var(--main-bg-color)"
      }}>
        <DashboardNavbar />
      </div>
      <DashboardLayout>
        <SoftBox my={-3}>
          <Schedules />
        </SoftBox>
      </DashboardLayout>
    </>
  );
};

export default Calendar;
